import { CaretDownOutlined } from '@ant-design/icons'
import { Button, MenuProps } from 'antd'
import { Dropdown, Menu } from 'antd'
import { useAuth } from 'state'
import { useCssInJs } from 'hooks/useCssInJs'
import { genUserInfoMenuItemStyle, genUserInfoStyle } from './styles'
import cls from 'classnames'

interface IUserInfoMenuItemProps {
  user: api.sso.User
  onLogoutClick: () => void
}
function UserInfoMenuItem(props: IUserInfoMenuItemProps) {
  const { user, onLogoutClick } = props
  const prefix = 'user-info-menu-item'
  const { wrapSSR, hashId } = useCssInJs({
    prefix,
    styleFun: genUserInfoMenuItemStyle,
  })
  return (
    <div className={cls(prefix, hashId)}>
      <div className='user-info-all'>
        <p className={'user-info'}>
          <span className={'user-name'}>{user.userName}</span>
          <span className={'user-post-name'}>{user.postName}</span>
          <span className={'user-phone'}>{user.userPhone}</span>
        </p>
        <p className='org-path-name'>{user.orgPathName}</p>
      </div>
      <div>
        <Button size={'small'} onClick={onLogoutClick}>
          退出登录
        </Button>
      </div>
    </div>
  )
}

export function UserInfo() {
  const { user, logout } = useAuth()
  const prefix = 'user-info'
  const { wrapSSR, hashId } = useCssInJs({
    prefix,
    styleFun: genUserInfoStyle,
  })

  return wrapSSR(
    <Dropdown
      arrow
      placement='bottomLeft'
      dropdownRender={(menu) => (
        <UserInfoMenuItem user={user} onLogoutClick={logout} />
      )}
    >
      <div className={cls(prefix, hashId)}>
        <span>{user.userName}</span>
        <span>{user.orgPathName?.split('/').pop()}</span>
        <span>
          <CaretDownOutlined />
        </span>
      </div>
    </Dropdown>
  )
}
